<div [class.active]="open$ | async" class="gamburger d-flex d-md-none flex-wrap align-items-center"
     (click)="toggleSidebar()">
  <div></div>
  <div></div>
  <div></div>
</div>
<div class="sidebar-menu-wrap h-100" [class.compact]="compact" [class.vh-100]="!compact">

  <div [class.active]="open$ | async"
       class="sidebar-menu h-100 d-flex flex-column justify-content-between">
    <div (click)="toggleSidebar()" class="sidebar-backdrop d-block d-md-none"></div>
    <div>

      <a routerLink="/">
        <i-feather name="teleseller" class="teleseller-logo normal autosize"></i-feather>
      </a>
      <ul (click)="toggleSidebar()" class="mt-3">
        <!--<li>
          <a (click)="interfaceService.setFullSize(this.renderer)" routerLinkActive="active" routerLink="/leads">
            <i-feather name="lead" class="mr-2"></i-feather>&nbsp;<span>Лиды</span>
          </a>
        </li>
        <li>
          <a (click)="interfaceService.setFullSize(this.renderer)" routerLinkActive="active" routerLink="/tasks">
            <i-feather name="tasks" class="mr-2"></i-feather>&nbsp;<span>Задания</span>
          </a>
        </li>-->
        <li class="mb-6">
          <a routerLinkActive="active" routerLink="/ui" class="pointer" (click)="goToMessenger()">
            <i-feather name="chat" class="mr-2"></i-feather>&nbsp;<span>Мессенджер</span>
          </a>
        </li>
        <li *ngIf="senderService.isAdmin()">
          <a (click)="senderService.openSenderChat()" [class.active]="allService._openChatId === 'sender'"
             class="pointer">
            <i-feather name="message-square" class="mr-2"></i-feather>&nbsp;<span>Рассылки</span>
          </a>
        </li>
        <li>
          <a (click)="senderService.openHelpChat()" [class.active]="allService._openChatId === senderService.helpChatId"
             class="pointer">
            <i-feather name="life-buoy" class="mr-2"></i-feather>&nbsp;<span>Техподдержка</span>
          </a>
        </li>
        <!--<li *ngIf="senderService.isAdmin()">
          <a (click)="senderService.openSenderPartnerList()" [class.active]="allService._openChatId === 'partner'"
             class="pointer">
            <i-feather name="dollar-sign" class="mr-2"></i-feather>&nbsp;<span>Партнерка</span>
          </a>
        </li>
        <li>
          <a (click)="senderService.openInfoChat()" [class.active]="allService._openChatId === '@teleseller_chat'"
             class="pointer">
            <i-feather name="info" class="mr-2"></i-feather>&nbsp;<span>Наш&nbsp;чат</span>
          </a>
        </li>
        <li>
          <a (click)="modalService.openModal('ModalFirstFaqVideoComponent')" class="pointer">
            <i-feather name="video" class="mr-2"></i-feather>&nbsp;<span>Обущающее&nbsp;видео</span>
          </a>
        </li>-->
        <!--<li>
          <a class="pointer d-flex" (click)="modalService.openModal('ModalAddBalanceComponent')">
            <i-feather name="credit-card" class="mr-2"></i-feather>&nbsp;Баланс
            <span *ngIf="(senderService.account$ | async)?.balance !== false"
                  class="badge-primary badge">{{ (senderService.account$ | async)?.balance | number }} ₽</span>
          </a>
        </li>-->
      </ul>

    </div>
    <div *ngIf="(senderService.account$ | async) as account" class="tarif mb-3 align-self-end text-center">
      <h5 class="text-white">
        Полный тариф
        <i-feather name="full" class="ml-2"></i-feather>
      </h5>
      <div class="mb-3">
        <ng-template [ngIf]="account.tariff === 'test'">
          {{ account.tariff_paid  | timeago }} {{(senderService.expiredTariff$ | async) ? 'закончился' : 'закончится'}}
          пробный период
        </ng-template>
        <ng-template [ngIf]="account.tariff === 'full' || account.tariff === 'start'">
          {{ account.tariff_paid  | timeago }} {{(senderService.expiredTariff$ | async) ? 'закончился' : 'закончится'}}
          месячный абонимент
        </ng-template>
      </div>
      <div *ngIf="(expiredTariff$ | async) || account.tariff === 'start'">

        <button (click)="openPayTariff()" nz-button nzType="default" class="border-0" nzSize="large" nzShape="round">
          Оплатить
        </button>
        <!--<div class="mb-3" *ngIf="account.tariff === 'test'">
        <span class="text-underline pointer" (click)="showPromoCode$.next(true)" *ngIf="!(showPromoCode$ | async)">
          Промокод
        </span>
          <nz-form-control *ngIf="(showPromoCode$ | async)" [nzValidateStatus]="promoCodeStatus()"
                           nzWarningTip=""
                           nzErrorTip=""
                           nzHasFeedback>
            <input class="promo-code-input" nz-input placeholder="Введите код" [(ngModel)]="promoCode"/>
          </nz-form-control>
        </div>
        <button (click)="paidTariff()" nz-button nzType="default" class="border-0" nzSize="large" nzShape="round">
          Оплатить
        </button>

        <div class="tariff-price">
          <small *ngIf="!hasPromoCode">{{senderService.tariffPrice}} ₽</small>
          <small *ngIf="hasPromoCode">{{senderService.calcTariffPrice(promoCode)}} ₽</small>
        </div>-->
      </div>
    </div>
  </div>
</div>
